module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_reporting_pane_white.044b6846.png";